import { client } from '../util/createRestApiClient';
import { loading } from './index';

const base = 'eform-links';

export default () => ({
  getAll: () => loading(client.request({
    method: 'GET',
    url: base + '?timestamp=' + new Date().getTime()
  })),
  add: (params) => client.request({ method: 'POST', url: base, data: params }),
  update: (id, params) => client.request({ method: 'PUT', url: base + '/' + id, data: params }),
  delete: (id) => client.request({ method: 'DELETE', url: base + '/' + id })
});
